import { c as _c } from "react/compiler-runtime";
import { type ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@shared-components/shadcn/chart";
import { api } from "@shared-server/api";
import { Bar, ComposedChart, CartesianGrid, XAxis, YAxis, Legend } from "recharts";
import { COLORS, formatGranularDateTick } from "./metric-utils";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";
import { useDepartmentStackContext } from "@shared-components/department-stack-provider";
const chartConfig: ChartConfig = {
  count: {
    label: "Images"
  }
};
type ImagesProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};
export const ImagesWithDepartments = props => {
  const $ = _c(22);
  const {
    parentDepartmentId
  } = useDepartmentStackContext();
  let t0;
  if ($[0] !== parentDepartmentId || $[1] !== props.endDate || $[2] !== props.granularity || $[3] !== props.startDate) {
    t0 = {
      startDate: props.startDate,
      endDate: props.endDate,
      granularity: props.granularity,
      parentDepartmentId
    };
    $[0] = parentDepartmentId;
    $[1] = props.endDate;
    $[2] = props.granularity;
    $[3] = props.startDate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const coreMetricsQuery = api.coreMetrics.imagesAttemptedByDepartment.useQuery(t0);
  let t1;
  if ($[5] !== coreMetricsQuery.data?.chartDepartmentData) {
    t1 = coreMetricsQuery.data?.chartDepartmentData ?? [];
    $[5] = coreMetricsQuery.data?.chartDepartmentData;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const chartData = t1;
  let t2;
  if ($[7] !== coreMetricsQuery.data?.departments) {
    t2 = coreMetricsQuery.data?.departments ?? [];
    $[7] = coreMetricsQuery.data?.departments;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const departments = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="mb-4">{"Images"}</h2>;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CartesianGrid vertical={false} />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props.granularity) {
    t5 = <XAxis dataKey="date" tickLine={false} axisLine={false} tickMargin={8} minTickGap={32} tickFormatter={value => formatGranularDateTick(value, props.granularity)} />;
    $[11] = props.granularity;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <YAxis yAxisId="countItems" interval={1} orientation="left" />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChartTooltip content={<ChartTooltipContent nameKey="date" wrapperStyle={{
      zIndex: 1
    }} itemsContainerClassName="grid grid-cols-3 gap-2" labelFormatter={_temp} />} />;
    t8 = <Legend />;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  let t9;
  if ($[16] !== departments) {
    t9 = departments.map(_temp2);
    $[16] = departments;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== chartData || $[19] !== t5 || $[20] !== t9) {
    t10 = <div>{t3}<ChartContainer config={chartConfig} className="aspect-auto h-[150px] w-full"><ComposedChart accessibilityLayer={true} data={chartData}>{t4}{t5}{t6}{t7}{t8}{t9}</ComposedChart></ChartContainer></div>;
    $[18] = chartData;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
function _temp(value_0) {
  return value_0;
}
function _temp2(department, departmentIndex) {
  return <Bar key={department.id} yAxisId="countItems" dataKey={department.id} name={department.name} fill={COLORS[departmentIndex % COLORS.length]} />;
}